export default {
  GET_ALL: `#graphql
  query getFraudCases($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getFraudCases(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final)
    {
      docs {
        _id
        number
        code
        status
        originOrder
        triggerLine
        riskLevel
        brand
        alerts {
          line
          riskLevel
          order
          keyword
          originalDescription
          reason
          createdAt
        }
        orders {
          order
          name
          phone
          email
          address
          location
          community
          total
          methodPay
          payStatus
          payAttempts
          lastFour
          cardType
          pays {
            methodPay
            cardType
            lastFour
            state
            error
            value
          }
          createdAt
          paidAt
          isWholesaler
          relationType
          matches {
            phone
            email
            nameWords
            addressSegments
            location
            community
          }
          review {
            status
            reviewedAt
            reviewedBy
          }
          fraudDismissedCount
          fraudConfirmedCount
          relatedTo
          verifiedAt
          bannedAt
          bannedBy
          aiReason
          aiConfidence
          aiAssessment
          aiEvidence
          reportNumber
        }
        closedAt
        aiReviewedAt
        aiModel
        createdAt
        updatedAt
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`,

  REVIEW: `#graphql
  mutation reviewFraudOrder($code: String!, $order: String!, $status: String!) {
    reviewFraudOrder(code: $code, order: $order, status: $status) {
      _id
      number
      code
      status
      originOrder
      triggerLine
      riskLevel
      brand
      alerts {
        line
        riskLevel
        order
        keyword
        originalDescription
        reason
        createdAt
      }
      orders {
        order
        name
        phone
        email
        address
        location
        community
        total
        methodPay
        payStatus
        payAttempts
        lastFour
        cardType
        pays {
          methodPay
          cardType
          lastFour
          state
          error
          value
        }
        createdAt
        paidAt
        isWholesaler
        relationType
        matches {
          phone
          email
          nameWords
          addressSegments
          location
          community
        }
        review {
          status
          reviewedAt
          reviewedBy
        }
        fraudDismissedCount
        fraudConfirmedCount
        relatedTo
        verifiedAt
        bannedAt
        bannedBy
        aiReason
        aiConfidence
        aiAssessment
        aiEvidence
        reportNumber
      }
      closedAt
      aiReviewedAt
      aiModel
      createdAt
      updatedAt
    }
  }`,

  REVIEW_ORDERS: `#graphql
  mutation reviewFraudOrders($code: String!, $orders: [String!]!, $status: String!) {
    reviewFraudOrders(code: $code, orders: $orders, status: $status) {
      _id
      number
      code
      status
      originOrder
      triggerLine
      riskLevel
      brand
      alerts {
        line
        riskLevel
        order
        keyword
        originalDescription
        reason
        createdAt
      }
      orders {
        order
        name
        phone
        email
        address
        location
        community
        total
        methodPay
        payStatus
        payAttempts
        lastFour
        cardType
        pays {
          methodPay
          cardType
          lastFour
          state
          error
          value
        }
        createdAt
        paidAt
        isWholesaler
        relationType
        matches {
          phone
          email
          nameWords
          addressSegments
          location
          community
        }
        review {
          status
          reviewedAt
          reviewedBy
        }
        fraudDismissedCount
        fraudConfirmedCount
        relatedTo
        verifiedAt
        bannedAt
        bannedBy
        aiReason
        aiConfidence
        aiAssessment
        aiEvidence
        reportNumber
      }
      closedAt
      aiReviewedAt
      aiModel
      createdAt
      updatedAt
    }
  }`,

  DISMISS_ALL_PENDING: `#graphql
  mutation dismissAllPendingFraudOrders($code: String!) {
    dismissAllPendingFraudOrders(code: $code) {
      _id
      number
      code
      status
      originOrder
      triggerLine
      riskLevel
      brand
      alerts {
        line
        riskLevel
        order
        keyword
        originalDescription
        reason
        createdAt
      }
      orders {
        order
        name
        phone
        email
        address
        location
        community
        total
        methodPay
        payStatus
        payAttempts
        lastFour
        cardType
        pays {
          methodPay
          cardType
          lastFour
          state
          error
          value
        }
        createdAt
        paidAt
        isWholesaler
        relationType
        matches {
          phone
          email
          nameWords
          addressSegments
          location
          community
        }
        review {
          status
          reviewedAt
          reviewedBy
        }
        fraudDismissedCount
        fraudConfirmedCount
        relatedTo
        verifiedAt
        bannedAt
        bannedBy
        aiReason
        aiConfidence
        aiAssessment
        aiEvidence
        reportNumber
      }
      closedAt
      aiReviewedAt
      aiModel
      createdAt
      updatedAt
    }
  }`
}

export const fraudCasesClosedQueries = {
  GET_ALL: `#graphql
  query getFraudCasesClosed($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getFraudCasesClosed(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final)
    {
      docs {
        _id
        number
        code
        status
        originOrder
        triggerLine
        riskLevel
        brand
        alerts {
          line
          riskLevel
          order
          keyword
          originalDescription
          reason
          createdAt
        }
        orders {
          order
          name
          phone
          email
          address
          location
          community
          total
          methodPay
          payStatus
          payAttempts
          lastFour
          cardType
          pays {
            methodPay
            cardType
            lastFour
            state
            error
            value
          }
          createdAt
          paidAt
          isWholesaler
          relationType
          matches {
            phone
            email
            nameWords
            addressSegments
            location
            community
          }
          review {
            status
            reviewedAt
            reviewedBy
          }
          fraudDismissedCount
          fraudConfirmedCount
          relatedTo
          verifiedAt
          bannedAt
          bannedBy
          aiReason
          aiConfidence
          aiAssessment
          aiEvidence
          reportNumber
        }
        closedAt
        aiReviewedAt
        aiModel
        createdAt
        updatedAt
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`,
  REVIEW: `#graphql
  mutation reviewFraudOrder($code: String!, $order: String!, $status: String!) {
    reviewFraudOrder(code: $code, order: $order, status: $status) {
      _id
      number
      code
      status
      originOrder
      triggerLine
      riskLevel
      brand
      alerts {
        line
        riskLevel
        order
        keyword
        originalDescription
        reason
        createdAt
      }
      orders {
        order
        name
        phone
        email
        address
        location
        community
        total
        methodPay
        payStatus
        payAttempts
        lastFour
        cardType
        pays {
          methodPay
          cardType
          lastFour
          state
          error
          value
        }
        createdAt
        paidAt
        isWholesaler
        relationType
        matches {
          phone
          email
          nameWords
          addressSegments
          location
          community
        }
        review {
          status
          reviewedAt
          reviewedBy
        }
        fraudDismissedCount
        fraudConfirmedCount
        relatedTo
        verifiedAt
        bannedAt
        bannedBy
        aiReason
        aiConfidence
        aiAssessment
        aiEvidence
        reportNumber
      }
      closedAt
      aiReviewedAt
      aiModel
      createdAt
      updatedAt
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/fraudCase.js